import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
    selector: '[pAddEllipsisIfOverflow]'
})
export class AddEllipsisDirective implements AfterViewInit, OnDestroy {
    private hostElement!: HTMLElement;
    private appendedElement!: HTMLElement;

    private isAppended = false;

    private resize$!: ResizeObserver;

    constructor(private readonly el: ElementRef) {}

    public ngAfterViewInit(): void {
        this.hostElement = this.el.nativeElement as HTMLElement;
        this.appendedElement = this.createEllipssElement();

        this.checkAndUpdate();

        this.resize$ = new ResizeObserver(this.checkAndUpdate.bind(this));
        this.resize$.observe(this.hostElement);
    }

    private createEllipssElement(): HTMLSpanElement {
        const ellipsisElement = document.createElement('span');
        ellipsisElement.textContent = '...';
        ellipsisElement.style.wordBreak = 'normal';
        ellipsisElement.style.overflowWrap = 'normal';
        ellipsisElement.style.whiteSpace = 'normal';
        ellipsisElement.style.alignSelf = 'flex-end';
        return ellipsisElement;
    }

    public ngOnDestroy(): void {
        this.resize$.disconnect();
    }

    private checkAndUpdate(): void {
        if (this.shouldAddEllipsis == this.isAppended) {
            return;
        }
        if (this.shouldAddEllipsis && !this.isAppended) {
            this.appendEllipsis();
        }
        if (!this.shouldAddEllipsis && this.isAppended) {
            this.removeEllipsis();
        }
    }

    private get shouldAddEllipsis(): boolean {
        return this.hostElement.scrollWidth > this.hostElement.clientWidth || this.hostElement.scrollHeight > this.hostElement.clientHeight;
    }

    private appendEllipsis(): void {
        this.hostElement.appendChild(this.appendedElement);
        this.isAppended = true;
    }

    private removeEllipsis(): void {
        this.hostElement.removeChild(this.appendedElement);
        this.isAppended = false;
    }
}
